import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React from 'react';
import { LayoutContext } from './index.js';

var _excluded = ["as", "className"];
var LayoutMenuButton = function LayoutMenuButton(_ref) {
  var As = _ref.as,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _React$useContext = React.useContext(LayoutContext),
    isHeaderFixed = _React$useContext.isHeaderFixed;
  var finalClasses = classnames('C-Layout__menuButton', {
    '--fixed': isHeaderFixed
  }, className);
  return /*#__PURE__*/React.createElement(As, _extends({
    className: finalClasses
  }, otherProps));
};
LayoutMenuButton.displayName = 'Layout.MenuButton';
LayoutMenuButton.defaultProps = {
  as: 'div'
};

export { LayoutMenuButton as default };
